// RequireAdmin.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function RequireAdmin({ user, children }) {
  if (user?.user_type !== "admin") {
    toast.error("Unauthorized");
    return <Navigate to="/iocs" replace />;
  }

  return children;
}
